import React from "react";
import { Space } from "antd";
import { Content } from "antd/es/layout/layout";
import { GrindorLineage } from "./GrindorLineage";
import { GrindorTrigger } from "./GrindorTrigger";
import { GrindorStatus } from "./GrindorStatus";
import { GrindorMultiSelectTrigger } from "./GrindorMultiSelectTrigger";
import { GrindorJobs } from "./GrindorJobs";

interface GrindorParams {
  customer: string;
  product: string;
  version: number;
  userName: string;
}

export const Grindor: React.FC<GrindorParams> = ({
  customer,
  product,
  version,
  userName,
}) => {
  return (
    <Content style={{}}>
      <Space direction={"vertical"} size={"large"}>
        <div>
          <h3>Manual Trigger:</h3>
          <GrindorTrigger
            customer={customer}
            product={product}
            version={version}
            userName={userName}
          />
        </div>
        <div>
          <h3>Jobs:</h3>
          <GrindorJobs
            customer={customer}
            product={product}
            version={version}
          />
        </div>
        <div style={{ width: "100%", height: "100%" }}>
          <h3>Trigger Lineage:</h3>
          <GrindorLineage
            customer={customer}
            product={product}
            version={version}
          />
        </div>
      </Space>
    </Content>
  );
};

interface GrindorMultiSelectParams {
  slug: string;
  products: string[];
  userName: string;
}

export const GrindorMultipleCustomers: React.FC<GrindorMultiSelectParams> = ({
  slug,
  products,
  userName,
}) => {
  return (
    <Content style={{}}>
      <Space direction={"vertical"} size={"large"}>
        <div>
          <h3>Manual Trigger:</h3>
          <GrindorMultiSelectTrigger
            slug={slug}
            products={products}
            userName={userName}
          />
        </div>
      </Space>
    </Content>
  );
};
